import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { ReactiveFormsModule } from "@angular/forms";
import { FormlyFieldConfig, FormlyModule } from "@ngx-formly/core";
import { FormlyMaterialModule } from "@ngx-formly/material";
import { FormlyMatToggleModule } from "@ngx-formly/material/toggle";
import { FormlyMatDatepickerModule } from "@ngx-formly/material/datepicker";
import { FormlyMatSliderModule } from "@ngx-formly/material/slider";

import { MaterialModule } from "../material.module";

import { ArrayTypeComponent } from "./array.type";
import { FileTypeComponent } from "./file.type";
import { HorizontalStepperTypeComponent } from "./horizontal-stepper.type";
import { MultiSchemaTypeComponent } from "./multischema.type";
import { NullTypeComponent } from "./null.type";
import { ObjectTypeComponent } from "./object.type";
import { TabsTypeComponent } from "./tabs.type";
import { VerticalStepperTypeComponent } from "./vertical-stepper.type";

export function typeValidationMessage({ schemaType }: any) {
  return `Deve ser "${schemaType[0]}".`;
}

export function minlengthValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ter pelo menos ${field.templateOptions.minLength} caracteres.`;
}

export function maxlengthValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ter menos de ${field.templateOptions.maxLength} caracteres.`;
}

export function minValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ser maior ou igual a ${field.templateOptions.min}.`;
}

export function maxValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ser menor ou igual a ${field.templateOptions.max}.`;
}

export function multipleOfValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ser múltiplo de "${field.templateOptions.step}".`;
}

export function exclusiveMinimumValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ser maior que "${field.templateOptions.step}".`;
}

export function exclusiveMaximumValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ser menor que "${field.templateOptions.step}".`;
}

export function minItemsValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ter pelo menos ${field.templateOptions.minItems} itens.`;
}

export function maxItemsValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ter menos de ${field.templateOptions.maxItems} itens.`;
}

export function constValidationMessage(err: any, field: FormlyFieldConfig) {
  return `Deve ser igual a "${field.templateOptions.const}".`;
}

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormlyMaterialModule,
    FormlyModule.forRoot({
      types: [
        // Native
        { name: "string", extends: "input" },
        {
          name: "integer",
          extends: "input",
          defaultOptions: {
            templateOptions: {
              type: "number",
            },
          },
        },
        {
          name: "number",
          extends: "input",
          defaultOptions: {
            templateOptions: {
              type: "number",
            },
          },
        },
        { name: "boolean", extends: "checkbox" },
        // JsonSchema
        { name: "enum", extends: "select" },
        { name: "array", component: ArrayTypeComponent },
        { name: "object", component: ObjectTypeComponent },
        { name: "multischema", component: MultiSchemaTypeComponent },
        { name: "null", component: NullTypeComponent },
        // Custom
        { name: "file", component: FileTypeComponent, wrappers: ["form-field"] },
        {
          name: "horizontal-stepper",
          component: HorizontalStepperTypeComponent,
        },
        { name: "tabs", component: TabsTypeComponent },
        {
          name: "vertical-stepper",
          component: VerticalStepperTypeComponent,
        },
      ],
      validationMessages: [
        { name: "required", message: "Este campo é obrigatório." },
        { name: "type", message: typeValidationMessage },
        { name: "minlength", message: minlengthValidationMessage },
        { name: "maxlength", message: maxlengthValidationMessage },
        { name: "min", message: minValidationMessage },
        { name: "max", message: maxValidationMessage },
        { name: "multipleOf", message: multipleOfValidationMessage },
        { name: "pattern", message: "Deve ser um valor válido." },
        { name: "exclusiveMinimum", message: exclusiveMinimumValidationMessage },
        { name: "exclusiveMaximum", message: exclusiveMaximumValidationMessage },
        { name: "minItems", message: minItemsValidationMessage },
        { name: "maxItems", message: maxItemsValidationMessage },
        { name: "uniqueItems", message: "Os itens devem ser únicos." },
        { name: "const", message: constValidationMessage },
        { name: "enum", message: "Deve ser igual a um dos valores permitidos." },
      ],
      extras: {
        checkExpressionOn: 'modelChange',
        lazyRender: true,
        resetFieldOnHide: true,
      },
    }),
    MaterialModule,
    FormlyMatToggleModule,
    FormlyMatDatepickerModule,
    FormlyMatSliderModule,
  ],
  declarations: [
    ArrayTypeComponent,
    FileTypeComponent,
    HorizontalStepperTypeComponent,
    MultiSchemaTypeComponent,
    NullTypeComponent,
    ObjectTypeComponent,
    TabsTypeComponent,
    VerticalStepperTypeComponent,
  ],
  exports: [FormlyModule],
})
export class CustomFormlyModule {}
